<template>
  <footer class="footer">
    <p class="text-uppercase">&copy; adamfleishman.com</p>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  // data() {
  //   return {
  //     year: new Date().getFullYear()
  //   }
  // }
};
</script>
